import React, {useEffect, useState} from 'react';
import AppRolesService from "../../General/services/AppRolesService";
import {useIsAuthenticated, useMsal} from "@azure/msal-react";
import {ColumnDataType, DataTable, Popover, SimpleButton, Spinner, SquareButton} from "@tag/tag-components-react-v4";
import OrganisationService from "../../ACPP/services/OrganisationService";
import LogsService from "../services/LogsService";
import {CircleInfoFilled, FootballFilled} from "@tag/tag-icons";

function ActivityLogs() {
    const [loading, setLoading] = useState<boolean>(true);
    const [activityLogs, setActivityLogs] = useState<any>(true);

    useEffect(() => {
        loadActivityLogs();
    }, []);

    const columns = React.useMemo(
        () => [
            {accessorKey: 'timeStampStartedUtc', header: 'Request Time', meta: {dataType: 'datetime' as ColumnDataType}},
            {accessorKey: 'product', header: 'Product'},
            {accessorKey: 'action', header: 'Action'},
            {accessorKey: 'initiatorName', header: 'User'},
            {
                accessorKey: 'status', header: 'Status',
                cell: renderStatus,
            },
            {accessorKey: 'more', header: 'More', cell: renderButton},
        ],
        []
    );

    function renderButton({row}: any) {
        const filteredData = Object.entries(row.original)
            .filter(([key, value]) => key !== "eTag" && key !== "timestamp" && key !== "partitionKey" && value !== null)
            .map(([key, value]) => (
                <div key={key} style={{marginBottom: "4px"}}>
                    <strong>{key}:</strong> {String(value)}
                </div>
            ));

        return (
            <>
                <Popover
                    popoverFor={
                        <SquareButton
                            icon={<CircleInfoFilled/>}
                            onClick={() => console.log(row.original)}
                        />
                    }
                    placement="left"
                    aria-labelledby="title"
                    background="dark"
                >
                    <div>{filteredData}</div>
                </Popover>
            </>
        );
    }

    function renderStatus({row}: any) {
        if (row.original.timeStampErroredUtc) {
            return '🔴'
        } else if (row.original.timeStampCompletedUtc) {
            return '🟢'
        } else {
            return '⚪'
        }
    }

    const loadActivityLogs = async () => {
        setLoading(true);

        const activityLogs = await LogsService.getActivityLogs();
        setActivityLogs(activityLogs);

        setLoading(false);
    }

    const {accounts} = useMsal();
    const isAuthenticated = useIsAuthenticated();

    let content;
    content = <>
        <h1>Activity Logs</h1>
        <h4>Latest Privileged Action User Logs</h4>
        <DataTable
            isLoading={loading}
            loadingElement={
                <div style={{display: 'flex', justifyContent: 'center', margin: '20px 0'}}>
                    <Spinner>Waiting for data...</Spinner>
                </div>
            }
            columns={columns}
            data={activityLogs}
        />
    </>

    return (
        <>
            {content}
        </>
    )
}

export default ActivityLogs;
